// lotties
import airpods from '@/static/assets/renters/stuff/lg/airpods.json';
import guitar from '@/static/assets/renters/stuff/lg/guitar.json';
import phone from '@/static/assets/renters/stuff/lg/phone.json';
import shoe from '@/static/assets/renters/stuff/lg/shoe.json';
import airpodsMobile from '@/static/assets/renters/stuff/sm/airpods.json';
import guitarMobile from '@/static/assets/renters/stuff/sm/guitar.json';
import phoneMobile from '@/static/assets/renters/stuff/sm/phone.json';
import shoeMobile from '@/static/assets/renters/stuff/sm/shoe.json';

import styled from 'styled-components';
import { Flex } from '@lemonade-hq/cdk';
import { motion } from 'motion/react';
import { ParallaxAnimationBox } from '../shared/ParallaxAnimationBox';
import { useInView } from 'react-intersection-observer';
import { useEffect, useState } from 'react';
import { useIsClient } from '@/hooks/useIsClient';

const ParallaxContainer = styled(motion(Flex))`
  position: absolute;
  height: 100%;
  width: min(100%, 1440px);
  top: 0;
  left: 0;
  right: 0;
  margin-inline: auto;
  z-index: 2;
`;

export const MotionStuffLotties = () => {
  const isClient = useIsClient();

  const { ref, inView } = useInView({
    threshold: 0.7,
  });

  const [play, setPlay] = useState(false);

  useEffect(() => {
    setPlay(inView);
  }, [inView]);

  if (!isClient) return null;
  return (
    <ParallaxContainer
      ref={ref}
      animate={{
        opacity: [0, 1],
        delay: 0.5,
      }}
    >
      <ParallaxAnimationBox
        startPositionY={[-100, -150, -150]}
        endPositionY={[-50, 0, -90]}
        left={[-150, -150, -100]}
        right="auto"
        responsiveAnimation={[guitarMobile, guitarMobile, guitar]}
        play={play}
      />

      <ParallaxAnimationBox
        startPositionY={[600, 400, 400]}
        endPositionY={[450, 280, 300]}
        left={[20, 280, 500]}
        right="auto"
        responsiveAnimation={[airpodsMobile, airpodsMobile, airpods]}
        play={play}
      />

      <ParallaxAnimationBox
        startPositionY={[500, 450, 450]}
        endPositionY={[350, 250, 300]}
        left="auto"
        right={[-10, 200, 400]}
        responsiveAnimation={[phoneMobile, phoneMobile, phone]}
        play={play}
      />

      <ParallaxAnimationBox
        startPositionY={[300, 300, 200]}
        endPositionY={[100, 100, 0]}
        left="auto"
        right={[-100, -100, -100]}
        responsiveAnimation={[shoeMobile, shoeMobile, shoe]}
        play={play}
      />
    </ParallaxContainer>
  );
};
